import { render, staticRenderFns } from "./ValidarCodigoToken.vue?vue&type=template&id=22aab4a2&scoped=true&"
import script from "./ValidarCodigoToken.vue?vue&type=script&lang=js&"
export * from "./ValidarCodigoToken.vue?vue&type=script&lang=js&"
import style0 from "./ValidarCodigoToken.vue?vue&type=style&index=0&id=22aab4a2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22aab4a2",
  null
  
)

export default component.exports